import React, { useEffect, useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Faqs = () => {
  const navigate = useNavigate();
  const faqData = [
    {
      id: 0,
      question: "What is ActiveCampaign?",
      answer:
        "ActiveCampaign is a comprehensive email marketing, marketing automation, and CRM platform designed to help businesses of all sizes engage with their customers effectively. It combines email marketing, automation, sales automation, and machine learning to deliver personalized experiences that drive growth.",
    },
    {
      id: 1,
      question: "How does ActiveCampaign work?",
      answer:
        "ActiveCampaign works by allowing you to create targeted email campaigns, set up automated workflows based on customer behavior, manage your contacts and leads, and track the performance of your marketing efforts. The platform uses machine learning to optimize send times, subject lines, and content for better engagement.",
    },
    {
      id: 2,
      question:
        "Do I need a lot of technical experience to use ActiveCampaign?",
      answer:
        "You don't need to be a developer or a designer to use ActiveCampaign. Anyone can create email marketing campaigns and marketing automations on our platform. Our Automation Recipe Library contains hundreds of pre-built automations — no coding skills are required. If you do find yourself needing some help, feel free to reach out to our support team through our Contact page, or visit our Support Center.",
    },
    {
      id: 3,
      question: "How does the free trial work?",
      answer:
        "Our free trial gives you full access to all ActiveCampaign features for 14 days. You can send unlimited emails, create automations, manage contacts, and explore all our tools without any restrictions. No credit card is required to start your free trial, and you can upgrade to a paid plan at any time during or after the trial period.",
    },
    {
      id: 4,
      question: "What kind of support do you offer?",
      answer:
        "We offer comprehensive support including 24/7 email support, live chat during business hours, extensive documentation, video tutorials, webinars, and a community forum. Our support team consists of email marketing experts who can help you with everything from basic setup to advanced automation strategies.",
    },
    {
      id: 5,
      question: "Can I integrate ActiveCampaign with other tools?",
      answer:
        "Yes! ActiveCampaign integrates with over 870+ apps and services including WordPress, Shopify, Salesforce, Zapier, Facebook, Google Analytics, and many more. Our robust API also allows for custom integrations to fit your specific business needs.",
    },
  ];
  const [faqs, setFaqs] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(2);
  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? null : id);
  };
  const { authData, storeId } = useSelector((state) => state.loginSlice);

  const dispatch = useDispatch();
  const fetchFaqs = async () => {
    try {
      const res = await apiHandler({
        url: endpoint.GET_FAQS,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });
      //console.log(res.data.data);

      if (res.data) {
        setFaqs(res.data.data);
      }
    } catch (error) {
      //console.log("Error occured", error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  return (
    <>
      <div className="bg-light min-vh-100 py-5">
        <div className="row justify-content-center">
          <div className="col-10">
            {/* Header Section */}
            <div className="text-center mb-5">
              <h1 className="display-6 fw-bold text-dark mb-0">
                Frequently Asked Questions
              </h1>
            </div>

            {/* FAQ Accordion */}
            <div className="accordion accordion-flush" id="faqAccordion">
              {faqs.length > 0 &&
                faqs.map((faq) => (
                  <div
                    key={faq.question}
                    className="accordion-item border-0 mb-3"
                  >
                    <div className="card shadow-sm border-0 rounded-3">
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button fw-semibold py-3 px-3 border-0 rounded-3 ${
                            activeAccordion !== faq.question ? "collapsed" : ""
                          } ${
                            activeAccordion === faq.question
                              ? "bg-primary text-white shadow-none"
                              : "bg-light-grey"
                          }`}
                          type="button"
                          onClick={() => toggleAccordion(faq.question)}
                          style={{
                            fontSize: "1rem",
                            boxShadow: "none",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {faq.question}
                        </button>
                      </h2>
                      <div
                        className={`accordion-collapse collapse ${
                          activeAccordion === faq.question ? "show" : ""
                        }`}
                      >
                        <div className="accordion-body px-4 py-4 bg-white rounded-bottom">
                          <p className="text-muted mb-0 lh-lg">{faq.answer}</p>
                          {faq.question === 2 && (
                            <div className="mt-3">
                              <a
                                href="#"
                                className="text-primary text-decoration-none fw-semibold me-3"
                              >
                                Automation Recipe Library
                              </a>
                              <a
                                href="#"
                                className="text-primary text-decoration-none fw-semibold me-3"
                              >
                                Contact page
                              </a>
                              <a
                                href="#"
                                className="text-primary text-decoration-none fw-semibold"
                              >
                                Support Center
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            {/* Help Button */}
            <div className="text-center mt-5">
              <button
                className="btn btn-primary btn-lg rounded-pill px-3 py-2 fw-semibold shadow-sm"
                style={{
                  border: "none",
                  transition: "all 0.3s ease",
                }}
                onClick={() => navigate("/contact-us")}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 8px 25px rgba(79, 70, 229, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.1)";
                }}
              >
                Get help
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faqs;
